// @flow
import { useSelector } from 'react-redux';

import type { Node } from 'react';

type TProps = {
  children: Node,
  className?: string
};

function CatalogFiltersContainer({children, className}: TProps) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

export default CatalogFiltersContainer;
